/* ACC_BAL_Landingpage_101: offer checkout CTA and sticky bar (scrolls to the offer). */
(function () {
  var JSON_HEADERS = { 'Content-Type': 'application/json', Accept: 'application/json' };
  var busy = false;

  function inEditor() {
    return !!(window.Shopify && window.Shopify.designMode);
  }

  // Selected plan of the offer box that holds the clicked button.
  function selectedPlan(link, root) {
    var box = link.closest('[data-bal101-offer]') || root;
    var checked = box.querySelector('.bal101-plans input:checked');
    return checked ? checked.getAttribute('data-plan') || '' : '';
  }

  // Set every existing line of this variant to 0, so the cart never holds it twice
  // (also covers one-time vs subscription lines, which never merge).
  function removeExisting(variantId) {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) {
        if (!res.ok) throw new Error('cart read failed');
        return res.json();
      })
      .then(function (cart) {
        var updates = {};
        var found = false;
        (cart.items || []).forEach(function (line) {
          if (line.variant_id === variantId) {
            updates[line.key] = 0;
            found = true;
          }
        });
        if (!found) return;
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: JSON_HEADERS,
          body: JSON.stringify({ updates: updates })
        }).then(function (res) {
          if (!res.ok) throw new Error('cart update failed');
        });
      });
  }

  // Add the bundle once with the chosen plan, then open checkout.
  // On any failure fall back to the link's own href (a one-time cart permalink).
  function goToCheckout(root, link) {
    if (busy) return;

    var variantId = Number(link.getAttribute('data-bal101-checkout'));
    if (!variantId) {
      window.location.href = link.href;
      return;
    }

    busy = true;
    var item = { id: variantId, quantity: 1 };
    var plan = selectedPlan(link, root);
    if (plan) item.selling_plan = Number(plan);

    link.setAttribute('aria-busy', 'true');
    removeExisting(variantId)
      .then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: JSON_HEADERS,
          body: JSON.stringify({ items: [item] })
        });
      })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed');
        window.location.href = '/checkout';
      })
      .catch(function () {
        window.location.href = link.href;
      });
  }

  // Sticky button: scroll to the offer box and focus the selected plan.
  function scrollToOffer(root, link) {
    var id = (link.getAttribute('href') || '').replace(/^#/, '');
    var offer = (id && document.getElementById(id)) || root.querySelector('[data-bal101-offer]');
    if (!offer) return;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    offer.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });

    var plan = offer.querySelector('.bal101-plans input:checked') || offer.querySelector('.bal101-plans input');
    if (plan) {
      try {
        plan.focus({ preventScroll: true });
      } catch (err) {
        plan.focus();
      }
    }
  }

  // Copy the price of the checked plan into the sticky bar.
  function syncStickyPrice(root, offer) {
    var target = root.querySelector('[data-bal101-sticky-price]');
    if (!target) return;
    offer = offer || root.querySelector('[data-bal101-offer]');
    if (!offer) return;
    var checked = offer.querySelector('.bal101-plans input:checked');
    var label = checked && checked.closest('.bal101-plan');
    var price = label && label.querySelector('.bal101-plan__price');
    if (price && price.textContent.trim()) target.textContent = price.textContent.trim();
  }

  function onChange(e) {
    var input = e.target;
    if (!input.matches || !input.matches('.bal101-plans input')) return;
    syncStickyPrice(e.currentTarget, input.closest('[data-bal101-offer]'));
  }

  function initSticky(root) {
    var bar = root.querySelector('[data-bal101-sticky]');
    if (!bar) return;
    var hero = root.querySelector('.bal101-hero');
    var offers = root.querySelectorAll('[data-bal101-offer]');
    var pastHero = false;
    var visibleOffers = new Set();
    var observers = [];

    bar.hidden = false;
    function update() {
      var show = pastHero && visibleOffers.size === 0;
      bar.classList.toggle('is-visible', show);
      bar.inert = !show;
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    }

    if (!('IntersectionObserver' in window)) {
      pastHero = true;
      update();
      return;
    }

    if (hero) {
      var heroObs = new IntersectionObserver(function (entries) {
        var e = entries[entries.length - 1];
        pastHero = !e.isIntersecting && e.boundingClientRect.top < 0;
        update();
      });
      heroObs.observe(hero);
      observers.push(heroObs);
    } else {
      pastHero = true;
    }

    if (offers.length) {
      var offerObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) visibleOffers.add(e.target);
          else visibleOffers.delete(e.target);
        });
        update();
      });
      offers.forEach(function (o) { offerObs.observe(o); });
      observers.push(offerObs);
    }

    update();
    root._bal101Observers = observers;
  }

  function onClick(e) {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
    var root = e.currentTarget;

    var jump = e.target.closest('[data-bal101-scroll]');
    if (jump && root.contains(jump)) {
      e.preventDefault();
      scrollToOffer(root, jump);
      return;
    }

    var link = e.target.closest('[data-bal101-checkout]');
    if (!link || !root.contains(link)) return;
    e.preventDefault();
    e.stopImmediatePropagation(); // keep theme cart scripts from adding it again
    if (inEditor()) return; // no cart changes or redirects inside the theme editor
    goToCheckout(root, link);
  }

  function init(scope) {
    (scope || document).querySelectorAll('.bal101').forEach(function (root) {
      if (root.dataset.bal101Init) return;
      root.dataset.bal101Init = '1';
      root.addEventListener('click', onClick, true); // capture phase: runs before theme handlers on the link
      root.addEventListener('change', onChange);
      initSticky(root);
      syncStickyPrice(root); // also covers a plan restored by the browser on back navigation
    });
  }

  function destroy(scope) {
    (scope || document).querySelectorAll('.bal101').forEach(function (root) {
      root.removeEventListener('click', onClick, true);
      root.removeEventListener('change', onChange);
      (root._bal101Observers || []).forEach(function (o) { o.disconnect(); });
      root._bal101Observers = null;
      delete root.dataset.bal101Init;
    });
  }

  function resetBusy() {
    busy = false;
    document.querySelectorAll('[data-bal101-checkout][aria-busy]').forEach(function (el) {
      el.removeAttribute('aria-busy');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  // Reset the guard if the shopper comes back with the browser back button.
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    resetBusy();
    document.querySelectorAll('.bal101').forEach(function (root) { syncStickyPrice(root); });
  });

  if (!window.Bal101Bound) {
    window.Bal101Bound = true;
    document.addEventListener('shopify:section:load', function (e) {
      init(e.target);
    });
    document.addEventListener('shopify:section:unload', function (e) {
      destroy(e.target);
    });
  }
})();